export {default} from './ListingInfos';



// WEBPACK FOOTER //
// ./src/pages/ListingInfos/index.ts